import React, { useEffect, useState } from 'react'
import { Drawer, Button } from 'antd'
import './../../assets/scss/typography.scss'
import './index.scss'
import SearchList from 'components/shared/search/SearchList'
import useWindowDimensions from 'hooks/window-dimensions'
import { useAppParamsContext } from 'contexts/AppParamsContext'
import BasicEmpty from 'components/BasicEmpty'

const ChooseCarDrawer = (props) => {
  const {
    isOpenPopupList,
    listData,
    onClose,
    buttonText = 'Quay lại',
    title = ' ',
    showSearch,
    onSearchCallback = () => {},
    onSelectedItemChanged,
    hideFooter = false,
    drawerClassName = '',
    drawerHeight = '80dvh',
    closeIcon
  } = props

  const { width } = useWindowDimensions()
  const [searchText, setSearchText] = useState(undefined)
  
  const { appThemeName } = useAppParamsContext()
  // NOTE: Đối với theme BIDV, nút Quay lại ở footer sẽ bị ẩn đi (isFooterHidden = true) vì nó bị dư. 
  // Đồng thời các option (list-items) như chọn khu vực sẽ được sửa lại style: fontsize 16px, padding 16px 0, và căng chữ bên trái thay vì ở giữa.
  const isBidvTheme = appThemeName === 'BIDV'
  const isFooterHidden = hideFooter || isBidvTheme

  const handleChangeValue = async (item) => {
    onSelectedItemChanged(item)
    onClose()
  }

  const onSearch = (value) => {
    if (value?.length > 0) {
      onSearchCallback(value.toLowerCase().trim())
    }
    if (!value || value?.length <= 0) {
      onSearchCallback('')
    }
  }

  useEffect(() => {
    if (searchText === undefined || searchText === '') {
      onSearch('')
    }
  }, [searchText])

  return (
    <Drawer
      title={title}
      placement="bottom"
      width={width > 1280 ? '35%' : '100%'}
      height={drawerHeight}
      onClose={onClose}
      open={isOpenPopupList}
      destroyOnClose
      closeIcon={closeIcon}
      className={`popup-booking ${drawerClassName}`}
      bodyStyle={{
        paddingBottom: isFooterHidden ? 16 : 60
      }}>
      {showSearch && (
        <SearchList
          placeholder="Tìm kiếm"
          value={searchText}
          onClick={() => {
            setSearchText(undefined)
          }}
          className="w-100"
          onSearch={onSearch}
          onChange={(e) => {
            const val = e.target.value
            setSearchText(val)
            // Chỉ bidv thì mới cần search theo text gõ vì có mỗi trang /stations dùng nên ko ảnh hưởng logic cũ
            if (isBidvTheme) {
              onSearch(val)
            }
          }}
          onInput={(e) => {
            if (e?.target?.value?.length === 0) {
              setSearchText(e.target.value)
            }
          }}
        />
      )}

      <div style={{ display: 'grid' }}>
        {listData.length > 0 ? (
          listData.map((item) => (
            <button
              key={item.value || item.status}
              className={`list-items ${item.disable ? 'disabled-item' : ''}`}
              style={{ border: 'none' }}
              disabled={item.disable}
              onClick={() => handleChangeValue(item)}>
              {item.status || item.value}
            </button>
          ))
        ) : (
          <div className="p-2">
            <BasicEmpty description="Không tìm thấy kết quả phù hợp" />
          </div>
        )}
      </div>

      {!isFooterHidden && (
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            padding: '12px 24px',
            borderTop: '1px solid #f0f0f0',
            background: '#fff',
            textAlign: 'center'
          }}>
          <Button className="btn-ok" onClick={onClose}>
            {buttonText}
          </Button>
        </div>
      )}
    </Drawer>
  )
}

export default ChooseCarDrawer